var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('TimeView',{staticClass:"time-app",attrs:{"app":_vm.widget.object}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }